export const IconCertificate: {
  name: 'icon_certificate-5cd3bb85f5ae'
} = {
  name: 'icon_certificate-5cd3bb85f5ae'
}
